export class Client {
  constructor(
    public name: string = '',
    public website: string = '',
    public active: boolean = true,
    public primaryContact: string = '',
    public primaryEmail: string = '',
    public primaryPhoneNumber: string = '',
    public currency: string = '',
    public deleted: boolean = false
  ) {}
}
export class ClientId {
  constructor(
    public name: string = '',
    public website: string = '',
    public active: boolean = true,
    public id: string = '',
    public primaryContact: string = '',
    public primaryEmail: string = '',
    public primaryPhoneNumber: string = '',
    public currency: string = '',
    public deleted: boolean = false,
    public isActive?: boolean
  ) {}
}
